import { Link } from "@inertiajs/react"
import type { ComponentPropsWithoutRef } from "react"

import { Icon } from "@/components/icon"
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import type { NavItem } from "@/types"

export function NavFooter({
  items,
  className,
  ...props
}: ComponentPropsWithoutRef<typeof SidebarGroup> & {
  items: NavItem[]
}) {
  return (
    <SidebarGroup
      {...props}
      className={`group-data-[collapsible=icon]:p-0 ${className ?? ""}`}
    >
      <SidebarGroupContent>
        <SidebarMenu>
          {items.map((item) => (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton
                asChild
                className="text-neutral-300 hover:text-neutral-100"
              >
                {item.external ? (
                  <a
                    href={item.href}
                    target={item.target ?? "_blank"}
                    rel="noopener noreferrer"
                  >
                    {item.icon && (
                      <Icon iconNode={item.icon} className="h-5 w-5" />
                    )}
                    <span>{item.title}</span>
                  </a>
                ) : (
                  <Link href={item.href} prefetch>
                    {item.icon && (
                      <Icon iconNode={item.icon} className="h-5 w-5" />
                    )}
                    <span>{item.title}</span>
                  </Link>
                )}
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  )
}
